import { useCallback } from 'react';

export function useHaptic() {
  const trigger = useCallback(
    (type: 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' = 'light') => {
      if (!navigator.vibrate) return;
      const patterns: Record<string, number | number[]> = {
        light: 10,
        medium: 20,
        heavy: 30,
        success: [20, 30, 20],
        warning: [40, 20, 40],
        error: [50, 50, 50],
      };
      const pattern = patterns[type] || 10;
      try {
        navigator.vibrate(pattern);
      } catch {
        /* haptic not supported */ }
    },
    []
  );

  return { trigger };
}
